import React from "react";
import { Route, Switch, withRouter, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import Header from "components/SuperAdminHeader";
import Sidebar from "containers/SuperAdminSideNav/index";

import {
  ABOVE_THE_HEADER,
  BELOW_THE_HEADER,
  COLLAPSED_DRAWER,
  FIXED_DRAWER,
  HORIZONTAL_NAVIGATION,
} from "constants/ActionTypes";
import { isIOS, isMobile } from "react-device-detect";
import asyncComponent from "util/asyncComponent";
import TopNav from "components/TopNav";
import axios from "../../services/customer";
import { businessExceptionBasedAvailiablity } from "actions";

class App extends React.Component {
  componentDidMount() {
    if (
      this.props.user.business &&
      this.props.user.business.business_locations[0].exception_based_availability
    ) {
      this.props.businessExceptionBasedAvailiablity(
        this.props.user.business.business_locations[0].exception_based_availability
      );
    }
  }
  componentWillUnmount() {
    delete axios.defaults.headers.common.Authorization;
  }

  render() {
    (function() {
      const token = localStorage.getItem("token");
      if (token) {
        axios.defaults.headers.common.Authorization = `Bearer ${token}`;
      } else {
        axios.defaults.headers.common.Authorization = null;
        /* if setting null does not remove `Authorization` header then try
            delete axios.defaults.headers.common['Authorization'];
          */
      }
    })();

    const { match, drawerType, navigationStyle, horizontalNavPosition } = this.props;
    const drawerStyle = drawerType.includes(FIXED_DRAWER)
      ? "fixed-drawer"
      : drawerType.includes(COLLAPSED_DRAWER)
      ? "collapsible-drawer"
      : "mini-drawer";

    // set default height and overflow for iOS mobile Safari 10+ support.
    if (isIOS && isMobile) {
      document.body.classList.add("ios-mobile-view-height");
    } else if (document.body.classList.contains("ios-mobile-view-height")) {
      document.body.classList.remove("ios-mobile-view-height");
    }

    return (
      <div className={`app-container ${drawerStyle}`}>
        {/* <div className="joyride" /> */}
        <Sidebar />
        <div className="app-main-container">
          <div className="app-header">
            {navigationStyle === HORIZONTAL_NAVIGATION &&
              horizontalNavPosition === ABOVE_THE_HEADER && <TopNav styleName="app-top-header" />}
            <Header />
            {navigationStyle === HORIZONTAL_NAVIGATION &&
              horizontalNavPosition === BELOW_THE_HEADER && <TopNav />}
          </div>

          <main className="app-main-content-wrapper">
            <div className="app-main-content">
              <Switch>
                <Route
                  path={`${match.url}/services`}
                  component={asyncComponent(() => import("./Services"))}
                />
                <Route
                  path={`${match.url}/businesses`}
                  component={asyncComponent(() => import("./Business"))}
                />
                <Route
                  path={`${match.url}/businessprofile`}
                  component={asyncComponent(() => import("./BusinessProfile"))}
                />
                <Route
                  path={`${match.url}/users`}
                  component={asyncComponent(() => import("./Users"))}
                />
                <Route
                  path={`${match.url}/customers`}
                  component={asyncComponent(() => import("../routes/CustomerAdmin"))}
                />
                <Route
                  path={`${match.url}/servicecategories`}
                  component={asyncComponent(() => import("./Category"))}
                />
                <Route
                  path={`${match.url}/logout`}
                  component={asyncComponent(() => import("./Logout"))}
                />
                <Route component={asyncComponent(() => import("components/Error404"))} />
              </Switch>
            </div>
          </main>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ settings, login }) => {
  const { drawerType, navigationStyle, horizontalNavPosition } = settings;
  const { user } = login;
  return { drawerType, navigationStyle, horizontalNavPosition, user };
};
export default withRouter(
  connect(
    mapStateToProps,
    { businessExceptionBasedAvailiablity }
  )(App)
);



// WEBPACK FOOTER //
// ./app/SuperAdmin/index.js